export default "__VITE_ASSET__DJd5nb_$__"